<template>
  <b-row>
    <b-col>
      <h1>
        <span class="title ml-0">{{ title }}</span>
      </h1>
      <p class="lead" v-if="url">
        <b-button-group>
          <b-button
            variant="outline-primary"
            size="sm"
            :title="$t('browse')"
            v-b-toggle.sidebar
            @click="$emit('enableSidebar')"
          >
            <b-icon-book />
            <span class="button-label prio">{{ $t("browse") }}</span>
          </b-button>
        </b-button-group>
      </p>
    </b-col>
    <b-col>
      <div class="" style="text-align: right">
        <img
          src="../assets/img/LogomarcaMCTI2020.svg"
          alt=""
          srcset=""
          width="67"
        >
        <span class="title">Instituto Nacional de Pesquisas Espaciais</span>
      </div>
      <Source class="float-right" :title="title" :stacUrl="url" :stac="data" />
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "vuex";
import Source from "./Source.vue";
import { BIconBook } from "bootstrap-vue";

export default {
  name: "StacHeader",
  components: {
    BIconBook,
    Source,
  },
  computed: {
    ...mapState(["data", "url", "title"]),
  },
};
</script>

<style lang="scss" scoped>
h1 {
  word-break: break-word;
}
</style>
